import { v4 as uuid  } from 'uuid';

export default (
  state = { unsaved: [], elements: [], selectedTags: [], tags: [] },
  action
) => {
  switch (action.type) {
    case "COLLECTIONS/REPLACE": {
      return { ...state, elements: action.data.elements || [], reloadRequired: false };
    }
    case "COLLECTIONS/APPEND": {
      const newElements = action.data.elements || [];
      return { ...state, elements: [...state.elements, ...newElements] };
    }
    case "COLLECTIONS/REQUIRE_RELOAD": {
      return {
        ...state,
        reloadRequired: true
      };
    }
    case "COLLECTIONS/ENTITY/ADD": {
      const unsaved = state.unsaved || [];
      const { id } = action.payload;

      const entity = { id };

      return { ...state, unsaved: [...unsaved, entity], lastAddedEntity: null };
    }
    case "COLLECTIONS/ENTITY/SAVED": {
      return {
        ...state,
        unsaved: state.unsaved.filter(
          entity => entity.id !== action.payload.id
        ),
        lastAddedEntity: action.payload.entity
      };
    }

    case "COLLECTIONS/ENTITY/DELETE": {
      return {...state, elements: state.elements.filter((item, index) => item.id !== action.payload.id)};
    }

    case "COLLECTIONS/ENTITY/UPDATE": {
      if (!state.elements) return state;

      const entity = action.payload.entity;
      return {
        ...state,
        elements: state.elements.map(el => el.id === entity.id ? {...el, ...entity} : el)
      };
    }

    case "COLLECTIONS/ENTITY/UPDATING/START": {
      return { ...state, favorite_updating: "start" };
    }

    case "COLLECTIONS/ENTITY/UPDATING/FAIL": {
      return { ...state, favorite_updating: "fail" };
    }

    case "COLLECTIONS/ENTITY/UPDATING/FINISH": {
      return {
        ...state,
        favorite_updating: null,
        favorite: null,
        lastAddedEntity: null
      };
    }

    case "FAVORITE/ID": {
      return { ...state, favorite: { ...action.payload } };
    }
    case "FAVORITE/CANCEL": {
      return { ...state, favorite: null };
    }
    case "FAVORITE/QUERY": {
      return {
        ...state,
        query: action.payload.query,
        selectedTags: action.payload.tags
      };
    }
    default: {
      return state;
    }
  }
};
